import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const TryItYourself: React.FC = () => {
  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-3 sm:p-4 md:p-6 lg:p-8 xl:p-12 relative">
      {/* Back Arrow Button - Visible */}
      <button
        aria-label="Close"
        onClick={() => navigate('/')}
        className="absolute top-3 left-3 sm:top-4 sm:left-4 z-30 p-2 rounded-full border border-white/20 text-white hover:border-[#26ab4d] hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#26ab4d] transition-colors"
      >
        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Centered Video Player */}
      <div className="relative w-full max-w-5xl mx-auto aspect-video bg-black rounded-lg overflow-hidden border-2 border-[#26ab4d]/30 shadow-2xl">
        <video 
          ref={videoRef}
          className="w-full h-full object-contain"
          poster="/api-dev-portal.png"
          autoPlay
          muted
          loop
          playsInline
          controls
          controlsList="nodownload noremoteplayback"
        >
          <source src="/Bargad Video_tiy.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default TryItYourself;